import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { MatchingJobCardContext } from '../MatchingJobCard';

import { convertStringToLanguageKey } from 'utils/languageUtils';

import { JOB_OPPORTUNITIES_PRIVACY } from 'constants/jobOpportunitiesConstants';

const MatchingJobFooter = () => {
    const intl = useIntl();

    const { job } = useContext(MatchingJobCardContext);

    const jobPrivacyValue = Object.values(JOB_OPPORTUNITIES_PRIVACY).find(x => x._id === job.privacy)?.value;

    return (
        <div className="job-footer">
            <div className="job-labels">
                <p className={`box ${job.status.toLowerCase()}-status`}>{intl.formatMessage({ id: convertStringToLanguageKey(job.status) })}</p>
                <p className={`box ${jobPrivacyValue.toLowerCase()}-privacy`}>{intl.formatMessage({ id: convertStringToLanguageKey(jobPrivacyValue) })}</p>
                {job.priority && <p className={`box ${job.priority?.toLowerCase()}-priority`}>{intl.formatMessage({ id: convertStringToLanguageKey(job.priority) })} {intl.formatMessage({ id: "priority" })}</p>}
            </div>
            <div className="job-matching-score">
                {job.score} <small>/100</small>
            </div>
        </div>
    );
};

export default MatchingJobFooter;
